import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {storeTicketsUpdateReady} from '../redux/stores'
import apiService from '../services/apiservices'
import { headerDataUpdate, subHeaderDataUpdate,buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'
import {StoreTicketStatus,StoreTicketReasons} from './DropDowns/index'

import DateTimeField from "react-bootstrap-datetimepicker";



function filterUnwantedData(storesTicketsData) {
    // let data = {}
    // if (storesTicketsData && storesTicketsData.data && storesTicketsData.data) {
    //     data = storesTicketsData.data
    // }

    let newData = {}
            newData.id = storesTicketsData.id ? storesTicketsData.id : ""
            newData.store_name =  storesTicketsData.store.name ? storesTicketsData.store.name : "NA"
            newData.platform_name =storesTicketsData.platform_name ? storesTicketsData.platform_name : "NA"
            newData.type =storesTicketsData.type ? storesTicketsData.type : "NA"
            newData.status =storesTicketsData.status ? storesTicketsData.status : "NA"
            newData.created =storesTicketsData.created ? storesTicketsData.created : "NA"
            newData.remarks =storesTicketsData.remarks ? storesTicketsData.remarks : ""

            newData.hold_till=Helpers.getDateTimeFormatForUTC(storesTicketsData.hold_till)

            if(storesTicketsData.reason_id!==null){
                newData.reason_id=storesTicketsData.reason.id
                newData.reason_name=storesTicketsData.reason.name
            }


    return newData
}

class UpdateStoresTicket extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",

            brandName:null,
            remarks:null,

            status:null,

            reason: null,

            hold_till:null,

            storesTicketSelectedId:"",
            storesTicketsData:{},
            disabledDate:false,
            
            brandNameErrorText: false,
            brandNameErrorData: '',

            statusErrorText: false,
            statusErrorData: '',

            reasonErrorText: false,
            reasonErrorData: '',            

            remarksErrorText: false,
            remarksErrorData: '',

            subTitle:Constants.EDIT_STORE_TICKET
            
        }
        this.isComponentStillMounted = true

        this.brandNameComponent = null
        this.brandNameSection = null

        this.statusComponent = null
        this.statusSection = null

        this.reasonComponent = null
        this.reasonSection = null

        this.remarksComponent = null
        this.remarksSection = null
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        
        if(this.props.stores && this.props.stores.storesTicketSelectedId && this.props.stores.storesTicketSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.EDIT_STORE_TICKET))
            this.setState({subTitle: Constants.EDIT_STORE_TICKET})
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                storesTicketSelectedId:this.props.stores.storesTicketSelectedId
            });

        }else{
            this.props.history.goBack();
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoreTicketData();
    }



    componentDidMount() {

    }

    getStoreTicketData = () =>{
        this.brandNameSection = ReactDOM.findDOMNode(this.refs.brandNameSection)
        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)
        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)
        this.reasonSection = ReactDOM.findDOMNode(this.refs.reasonSection)
        
        
        this.props.dispatch(storeTicketsUpdateReady(false))
        if(this.props.stores && this.props.stores.storesTicketSelectedId && this.props.stores.storesTicketSelectedId !== null){
            apiService.getStoresTicketDetails(this.props.stores.storesTicketSelectedId)
                .then(responseData => {
                    
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {

                        let storesTicketsData=filterUnwantedData(responseData.data)

                        let hold_till=new Date();
                        if(storesTicketsData.hold_till && storesTicketsData.hold_till!=="" && storesTicketsData.hold_till!==undefined && storesTicketsData.hold_till!==null){
                            hold_till=storesTicketsData.hold_till
                        }
                        if(storesTicketsData.status==="HOLD"){
                            this.setState({
                                disabledDate:true 
                            });
                        }

                        this.setState({
                            storesTicketsData:storesTicketsData,
                            remarks:storesTicketsData.remarks,
                            status:storesTicketsData.status,
                            reason:storesTicketsData.reason_id,
                            hold_till:hold_till
                        })

                        this.remarksComponent.value=storesTicketsData.remarks
                        this.reasonComponent.value=storesTicketsData.reason_id
                        this.props.dispatch(storeTicketsUpdateReady(true))
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(storeTicketsUpdateReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Fetching stores tickets got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
        }

    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 100) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

   

    mandateValidation =(inputName,type)=>{
        let inputComponent =inputName+"Component"
        let inputErrorText =inputName+"ErrorText"
        let inputErrorData =inputName+"ErrorData"
        let inputSection =inputName+"Section"
        let errorMsg = Constants.NON_VALID_MSG_INPUT
        if(Constants.FORM_SELECT ===type){
            errorMsg= Constants.NON_VALID_MSG_SELECT
            console.log("input name :::",inputName)
            console.log("input data :::",this.state[inputName])
        }
        if(this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === ""){
            this[inputComponent].focus()
            this.setState({[inputErrorText]:true,[inputErrorData]:errorMsg})
            this[inputSection].className= this[inputSection].className.replace(" has-error", "")
            this[inputSection].className += " has-error"
            return { status: false, value: '' }
        }
        return { status: true }
    }

    onSaveClick = () => {
        let data ={}

        let statusObject = this.mandateValidation("status",Constants.FORM_SELECT)
        if (statusObject.status) {
            data.status = this.state.status
        } else {
            return
        }


        let remarksObject = this.mandateValidation("remarks",Constants.FORM_INPUT)
        if (remarksObject.status) {
            data.remarks = this.state.remarks
        } else {
            return
        }


        let reasonObject = this.mandateValidation("reason",Constants.FORM_SELECT)
        if (reasonObject.status) {
            data.reason_id = this.state.reason
        } else {
            return
        }


        if(data.status==="HOLD" && this.state.storesTicketsData.status==="NEW"){

            if(new Date()<new Date(this.state.hold_till)){
                data.hold_till=this.state.hold_till
            }else{
                alert("Hold till time should be greate than current date and time.")
                return
            }

        }


        this.props.dispatch(storeTicketsUpdateReady(false))
        let apiPayloadData=data

         apiService.updateStoreTicket(apiPayloadData,this.state.storesTicketsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(storeTicketsUpdateReady(true))
                        this.props.history.push("/dashboard/storestickets/list")
                    } else {

                        this.props.dispatch(storeTicketsUpdateReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(storeTicketsUpdateReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
      
        
    }

   storeTicketStatusChange = (data) => {
    this.statusComponent.value=data.value
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }


   storeTicketReasonsChange = (data) => {
    this.reasonComponent.value=data.value
        this.setState({
            reason :data.value,
            reasonErrorText: false,
            reasonErrorData: ''
        })
        this.reasonSection.className= this.reasonSection.className.replace(" has-error", "")
    }


dateTimeChange = (newDate) => {

    let formattedDate=Helpers.getDateTimeFormatForUTC(parseInt(newDate,10));

    this.setState({
        hold_till: formattedDate
    });

}

    integerValidation = (value) => {
        if (/\D/.test(value)) {
            return true
        } else {
            return false
        }
    }

    onCancelClick = () => {
        this.props.history.goBack()
    }
    
    render() {
        return (
            <div className="line-item-edit">

             <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>Update Ticket</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.store_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Platform :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.platform_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.type}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.status}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {(() => {



                                      if(this.state.storesTicketsData.status!=="NEW"){
                                         
                                        return (
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group">
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason :</label>
                                                            <div className="col-sm-9">
                                                                    {this.state.storesTicketsData.reason_name}
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group">
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks :</label>
                                                            <div className="col-sm-9">
                                                                    {this.state.storesTicketsData.remarks}
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                         })()}  




                                        {(() => {

                                             if(this.state.storesTicketsData.hold_till && this.state.storesTicketsData.hold_till!==null && this.state.storesTicketsData.hold_till!==undefined && this.state.storesTicketsData.status==="HOLD"){

                                        return (
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group">
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Hold till :</label>
                                                            <div className="col-sm-9">
                                                                    {this.state.storesTicketsData.hold_till}
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                         })()} 

                                         </div>

                                         <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                          <div className="box-footer">

                                          </div>


                                        {(() => {

                                       if(this.state.storesTicketsData.status==="NEW" || this.state.storesTicketsData.status==="HOLD"){
                                         
                                        return (



                                        <div className="col-md-12 col-sm-12 col-xs-12">

                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.reasonSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "center", paddingTop: "0px"}}>Reason *</label>
                                                    <div className="col-sm-9" ref={el => this.reasonComponent = el}>
                                                       
                                                    <StoreTicketReasons storeTicketReasonsChange={this.storeTicketReasonsChange} selectedValue={this.state.reason} />


                                                        <span className="help-block"style={{display: this.state.reasonErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.reasonErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "center", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            
                                        </div>

                                        )
                                    }

                                      })()} 

                                       <div className="col-md-12 col-sm-12 col-xs-12">


                                        {(() => {

                                       if(this.state.storesTicketsData.status==="NEW" || this.state.storesTicketsData.status==="HOLD"){
                                         
                                        return (

                                        
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.statusSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "center", paddingTop: "0px"}}>Status *</label>
                                                    <div className="col-sm-9" ref={el => this.statusComponent = el}>
                                                       
                                                    <StoreTicketStatus storeTicketStatusChange={this.storeTicketStatusChange} selectedValue={this.state.status} />


                                                        <span className="help-block"style={{display: this.state.statusErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.statusErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                                                                   

                                        )

                                    }
                                    })()} 



                                      

                                        {(() => {

                                       if(this.state.status==="HOLD" && this.state.storesTicketsData.status==="NEW"){
                                         
                                        return (


                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "center", paddingTop: "0px"}}>Hold till *</label>
                                                    <div className="col-sm-9">
                                                        <DateTimeField dateTime={new Date(this.state.hold_till)} onChange={this.dateTimeChange}/>
                                                    </div>
                                                </div>
                                            </div>

                                             )

                                    }
                                    })()}

                                     </div>
                                        
                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        stores: state.stores,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(UpdateStoresTicket))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/UpdateStoresTicket.js